(()=>{
 'use strict';
 const config=window.FoldFableShop||{};
 const root=config.root||window.Shopify?.routes?.root||'/';
 const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:config.currency||'GBP'}).format(value/100);
 async function request(path,body){
  let response;
  try{response=await fetch(root+path,{method:body?'POST':'GET',credentials:'same-origin',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});}
  catch{throw Error('The shop could not be reached. Please check your connection and try again.');}
  const data=await response.json().catch(()=>null);
  if(!response.ok||!data)throw Error(typeof data?.description==='string'?data.description:'Your cart could not be updated. Please try again.');
  return data;
 }
 function counts(cart){document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=String(cart.item_count));}
 window.FoldFableCart={root,money,add:async(id,properties)=>{
  // No automatic retry: an interrupted response may already have added the card.
  try{return await request('cart/add.js',{items:[{id,quantity:1,properties}]});}
  catch(error){throw Error(error.message+' Check your cart before trying again.');}
 }};
 request('cart.js').then(counts).catch(()=>{});
 window.addEventListener('pageshow',event=>{if(event.persisted)window.location.reload();});
 const form=document.querySelector('#ff-cart-form');if(!form)return;
 const status=document.querySelector('#ff-cart-status');
 let busy=false;
 form.addEventListener('click',async event=>{
  const button=event.target.closest('[data-cart-remove]');if(!button)return;
  event.preventDefault();if(busy)return;
  busy=true;status.textContent='Removing card…';form.setAttribute('aria-busy','true');
  form.querySelectorAll('button,input').forEach(el=>el.disabled=true);
  try{await request('cart/change.js',{id:button.dataset.cartRemove,quantity:0});window.location.reload();}
  catch(error){status.textContent=error.message;busy=false;form.removeAttribute('aria-busy');form.querySelectorAll('button,input').forEach(el=>el.disabled=false);}
 });
 // Native Shopify cart POST updates quantities before continuing to checkout.
 form.addEventListener('submit',event=>{if(busy){event.preventDefault();return;}busy=true;form.setAttribute('aria-busy','true');status.textContent=event.submitter?.name==='checkout'?'Opening secure checkout…':'Updating your cart…';});
})();
